export const NEWBUILDING_SLIDES_COUNT = 5;
